/**
 * Spoken equipment label ("reefer", "dry van") → direct_loads enum value.
 *
 * Pure helper shared by the voice post paths. Lives here (not in the hook
 * file) so the voice-builder mapper and its unit tests don't pull the
 * Supabase client in transitively.
 */

import { EQUIPMENT_FLAT_LIST } from "@/lib/equipmentTypes";

export function voiceEquipmentToEnum(spoken: string | null | undefined): string {
  if (!spoken) return "van";
  const norm = spoken.trim().toLowerCase();
  if (!norm) return "van";
  if (norm === "dry van" || norm === "dryvan") return "van";
  const exact = EQUIPMENT_FLAT_LIST.find((e) => e.name.toLowerCase() === norm);
  if (exact) return exact.enumValue;
  const byEnum = EQUIPMENT_FLAT_LIST.find((e) => e.enumValue === norm.replace(/[\s-]+/g, "_"));
  if (byEnum) return byEnum.enumValue;
  const partial = EQUIPMENT_FLAT_LIST.find(
    (e) => e.name.toLowerCase().includes(norm) || norm.includes(e.name.toLowerCase()),
  );
  return partial?.enumValue || "van";
}

/** True when the equipment (spoken label OR enum value) is a reefer. */
export const isReeferEquipment = (equipment: string | null | undefined): boolean =>
  !!equipment && /reefer|refrigerated/i.test(equipment);
